export default {
  "hierarchy": {
    "comparator": [
      "dateTimePicker-comparator"
    ]
  },
  "props": {
    "default": {
      "calendarIcon": "fak fa-lv-calendar",
      "calendarButtonVariant": "link",
      "clearButtonVariant": "link"
    },
    "comparator": {
      "calendarIcon": "fak fa-lv-calendar",
      "calendarButtonVariant": "actionBar",
      "clearButtonVariant": "actionBar",
      "clearIcon": "fak fa-lv-cancel"
    }
  }
}